<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <p class="mb-5 text-justify">
        Ingresar rango de fechas de los rechazos que desea consultar.
      </p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        pagination
        filtro
        showExportToExcel
        showFilterDates
        @click-event="clickEvent"
        @click-buscar="buscar"
        :perPage="perPage"
        :dataLength="dataLength"
      >
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha Reclamación'"
          v-bind:value="'fecha_reclamacion'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cédula'"
          v-bind:value="'cedula'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Pagaré'"
          v-bind:value="'pagare'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Código'"
          v-bind:value="'convenio'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Tipo de Rechazo'"
          v-bind:value="'detalle'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Descripción'"
          v-bind:value="'descripcion'"
        ></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      fecha_inicio: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD 00:00:00"),
      fecha_fin: this.$moment().format("YYYY-MM-DD 23:59:59"),
      perPage: 25,
      informe_url: "portal/informes/rechazo",
      fileName: "Rechazo ",
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading",
    }),
    dataLength() {
      return this.$store.getters["pages/total"];
    },
    data() {
      return this.$store.getters["pages/dataInformes"];
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    buscar(event) {
      this.fecha_inicio = event.fecha_inicio
      this.fecha_fin = event.fecha_fin
      this.loadData();
    },
    async clickEvent(data, slug) {
      this.fecha_inicio = data.fecha_inicio
      this.fecha_fin = data.fecha_fin
      switch (slug) {
        case "paginacion":
          this.perPage = data.nRows;
          this.loadData(data.nRows, data.page);
          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            let result = await this.$store.state.api.get(this.informe_url, {
              params: {
                paginar: 0,
                fecha_inicio : this.fecha_inicio,
                fecha_fin : this.fecha_fin
              },
            });
            let data = XLSX.utils.json_to_sheet(result.data.datos, {
              header: [
                "modelo",
                "fecha_reclamacion",
                // "fecha_rechazo",
                "cedula",
                "pagare",
                "convenio",
                "descripcion",
                "detalle",
              ],
            });

            data["A1"].v = "Modelo";
            data["B1"].v = "Fecha de reclamación";
            // data["C1"].v = "Fecha de rechazo";
            data["C1"].v = "Cédula";
            data["D1"].v = "Pagaré";
            data["E1"].v = "Código";
            data["F1"].v = "Descripción del rechazo";
            data["G1"].v = "Detalle";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, this.fileName);
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              this.fileName + ".xlsx"
            );
            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
      }
    },
    loadData(row, page = 1, paginar = 1) {
      this.$store.dispatch("pages/fetch", {
        endpoint: this.informe_url,
        params: {
          row: row,
          page: page,
          paginar: paginar,
          fecha_inicio : this.fecha_inicio,
          fecha_fin : this.fecha_fin
        },
      });
    },
  },
  mounted() {
    this.loadData(this.perPage, 1);
  },
};
</script>